export enum FieldKeys {
    swissAddress = 'swissAddress',
    abroadAddress = 'abroadAddress',
    maritalStatus = 'maritalStatus',
    expensesForOptimization = 'expensesForOptimization',
    mealAllowance = 'mealAllowance',
    representativeAllowance = 'representativeAllowance',
    bankAccount = 'bankAccount',
    lossOfIncome = 'lossOfIncome',
    cba = 'cba',
    accidentRate = 'accidentRate',
    otherJob = 'otherJob',
    workTime = 'workTime',
    paymentCurrency = 'paymentCurrency',
    treasury = 'treasury',
    workTimeContract = 'workTimeContract',
    workPermit = 'workPermit',
    invoiceCurrency = 'invoiceCurrency',
}
